import { render, staticRenderFns } from "./StaffMemberSearchItem.vue?vue&type=template&id=6edc2c28"
import script from "./StaffMemberSearchItem.vue?vue&type=script&lang=js"
export * from "./StaffMemberSearchItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports